import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-summary-singleline',
  imports: [],
  templateUrl: './card-summary-singleline.component.html',
  styleUrl: './card-summary-singleline.component.scss'
})
export class CardSummarySinglelineComponent {

  @Input() title: string = '';
  @Input() value: string = '';
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'  = 'md'; // 
  @Input() colorTitle: string = 'text-text'; // Default color, can be overridden
  @Input() colorValue: string = 'text-text';
}
